import React from 'react'

import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from '@mui/material/Paper';

export default function JobAideStatement({ statements, tl, dir }) {
  return (
    <>
      {statements.map((data, index) => (
        <Paper key={`statements-${data.title}-${index}`} elevation={0} variant="outlined" square className="p-16 pb-32 my-16">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                className="font-bold m-0 text-14"
              >
                {data.title}
              </Typography>
              <Divider className="my-16" />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} lg={2}>
                  <Typography className="text-14 font-semibold m-0">
                    Statement (TL):
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8} lg={10}>
                  <Typography 
                    className={`${tl} m-0 wysiwyg`}
                    dir={dir}
                    dangerouslySetInnerHTML={{ __html: data.content_tl }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} lg={2}>
                  <Typography className="text-14 font-semibold m-0">
                    Statement (EN):
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8} lg={10}>
                  <Typography 
                    className="m-0 text-14 wysiwyg"
                    dangerouslySetInnerHTML={{ __html: data.content_en }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  )
}
